// populateElements(contentMap)
// populateImages(imageMap)
// populateBackgrounds(backgroundMap)
// auto_height_elements()
// normalizeHeights(".reviews_carousel .item > .row");
// normalizeHeights(".signature_bundles_carousel .item > .row.d-flex");
// normalizeHeights(".product-image","desktop");
// normalizeHeights(".levive_stack p");
// jQuery(window).resize(function() {
//     pass_img_dataSrc_to_src()
//     populateImages(imageMap)
//     auto_height_elements(true)
//     normalizeHeights(".reviews_carousel .item > .row");
//     normalizeHeights(".signature_bundles_carousel .item > .row.d-flex");
//     normalizeHeights(".product-image","desktop");
//     normalizeHeights(".levive_stack p");
// }).resize();

//NOT USING THE ABOVE CAUSE USING THE BELOW

// Define a reusable function for all layout operations
function initializeLayout(isResize = false) {
    if (!isResize) {
        populateElements(contentMap);
        populateBackgrounds(backgroundMap);
    }
    if (isResize) {
        pass_img_dataSrc_to_src();
    } 
    populateImages(imageMap);
    auto_height_elements(isResize);
    normalizeWidths(".class-pages-skin-longevity #levive_splash .ll_button");
    normalizeHeights(".reviews_carousel .item > .row");
    normalizeHeights(".signature_bundles_carousel .item > .row.d-flex");
    normalizeHeights(".class-products-the-glow .product-image", "desktop");
    normalizeHeights(".class-products-the-glow .product-image", "desktop");
    normalizeHeights(".levive_stack p");
    normalizeHeights('.nmn_nad', 'both', 'shortest')
}

// Initial load
initializeLayout();

// Window resize handler
jQuery(window).resize(function() {
    initializeLayout(true);
}).resize();

$owl = $(".owl-carousel");
$owl.on('initialized.owl.carousel', function(e) {
    adjustOwlStagePosition(e, this);
});

$owl.on('changed.owl.carousel', function(e) {
    // Check if the carousel has been initialized
    if ($(this).data('owl.carousel')) {
        adjustOwlStagePosition(e, this);
    }
});
jQuery(document).ready(function () {
    stop_bg_videos_conditional()
       // Create the accordion container
    jQuery('.magic-accordion-h3-new h3').addClass('h4 fw-bold')
    var $accordion = $('<ul class="accordion"></ul>');
    
    // Collect all content for each h3 section
    var sections = [];
    
    $('.product_ingredients h3').each(function() {
        var $heading = $(this);
        var headingText = $heading.text();
        var $contentElements = $();
        
        // Collect all following elements until next h3 or end
        var $next = $heading.next();
        while ($next.length > 0 && !$next.is('h3')) {
            $contentElements = $contentElements.add($next);
            $next = $next.next();
        }
        
        if ($contentElements.length > 0) {
            sections.push({
                heading: headingText,
                elements: $contentElements
            });
        }
    });
    
    // Create accordion items from collected sections
    sections.forEach(function(section) {
        // Create the accordion item
        var $accordionItem = $('<li class="accordion-item"></li>');
        
        // Create the accordion thumb (header)
        var $accordionThumb = $('<h3 class="p accordion-thumb"></h3>');
        var $ingredientSpan = $('<span class="ll_ingredient"></span>').text(section.heading);
        $accordionThumb.append($ingredientSpan);
        
        // Create the accordion panel (content) as div and append all elements
        var $accordionPanel = $('<div class="accordion-panel"></div>');
        section.elements.each(function() {
            $accordionPanel.append($(this).clone());
        });
        
        // Assemble the accordion item
        $accordionItem.append($accordionThumb).append($accordionPanel);
        
        // Add to accordion container
        $accordion.append($accordionItem);
    });
    
    // Find the element containing '[INGREDIENTS]' text within .magic-accordion-h3-new
    $('product-info p').each(function() {
        if ($(this).text().trim() === '[INGREDIENTS]') {
            // Replace the element with the accordion
            $(this).replaceWith($accordion);            
        }
    });
    $('.product_ingredients').remove();
    initializeAccordion()

    console.log(window.announcementMap, announcementMap)
    // end product accordion builder stuff
  buildAllAnnouncementTickers(window.announcementMap);
  setTimeout(() => {
    initializeLayout();
  }, 100);
  jQuery(".ll_cards_carousel").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        mouseDrag : false,
      },
      480: {
        items: 1,
      },
      600: {
        items: 2,
      },
      768: {
        mouseDrag : true,
        items: 2,
      },
      900: {
        items: 3,
      },
      1024: {
        items: 3,
      },
      1200: {
        items: 4,
      },
      1400: {
        items: 4,
      },
      1600: {
        items: 5,
      },
      1800: {
        items: 5,
      },
      2000: {
        items: 6,
      },
      2400: {
        items: 7,
      },
    },
  });
  jQuery(".ll_cards_carousel_4_max").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        mouseDrag : false,
      },
      768: {
        mouseDrag : true,
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });
  jQuery(".ll_cards_carousel_3_max").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 10,
    autoHeight: false,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        mouseDrag : false,
      },
      768: {
        mouseDrag : true,
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  });
  jQuery(".ll_cards_carousel_wide").owlCarousel({
    loop: false,
    dots: true,
    pagination: false,
    margin: 10,
    autoHeight: false,    
    responsive: {
      0: {
        mouseDrag: false,
        touchDrag: true,
        stagePadding: 25,
        items: 1,
      },
      768: {
        items: 1,
        stagePadding: 25,
        mouseDrag: true,
      },
      992: {
        items: 2,
        stagePadding: 10,
      },
      1200: {
        items: 2,
        stagePadding: 20,
      },
    },
  });
  var $levive_gallery = $('.levive_gallery');
  levive_gallery();    
}); // document ready function


jQuery('#skin_longevity_carousel .owl-carousel').on('initialized.owl.carousel resized.owl.carousel', function(event) {
  setTimeout(() => {
    normalizeHeights(".risa_new_card_bottom_part");
  }, 1000);
});

// Show SG content by default, hide MY content
jQuery(".ll_card_item:not(.ll_card_wide)").each(function () {
  var $this = jQuery(this);
  var $a = $this.find("a");
  if ($a.length == 1) {
    $this.css("cursor", "pointer");
    $this.click(function () {
      window.location.href = $a.attr("href");
    });
  }
});
if (window.location.hostname == 'levivelabs.com') {
    if (window.Shopify.country == 'MY' || window.Shopify.country == 'BR') {
        jQuery('.show_MY').removeClass('hidden');
    	jQuery('.show_SG').addClass('hidden');
        jQuery('#my-link').addClass('active');
        jQuery('#sg-link').removeClass('active');
    } else { // default
        jQuery('.show_SG').removeClass('hidden');
    	jQuery('.show_MY').addClass('hidden');
    }
}

// SG link click handler
jQuery('#sg-link').click(function(e) {
    e.preventDefault();
    jQuery('.show_SG').removeClass('hidden');
    jQuery('.show_MY').addClass('hidden');
    
    // Update active class
    jQuery('#sg-link').addClass('active');
    jQuery('#my-link').removeClass('active');
});

// MY link click handler
jQuery('#my-link').click(function(e) {
    e.preventDefault();
    jQuery('.show_MY').removeClass('hidden');
    jQuery('.show_SG').addClass('hidden');
    
    // Update active class
    jQuery('#my-link').addClass('active');
    jQuery('#sg-link').removeClass('active');
});


// // Get the text content from the button span
// var buttonText = $('.disclosure__button > span').eq(0).text();

// // Extract the country name after the "|" symbol
// var country = buttonText.split('|')[1];

// if (country) {
//     // Trim whitespace and convert to lowercase for class name
//     var countryClass = country.trim().toLowerCase();
    
//     // Replace spaces with hyphens for valid CSS class name
//     countryClass = countryClass.replace(/\s+/g, '-');
    
//     // Add the class to the body
//     $('body').addClass('country-' + countryClass);
// }
// // Get the current path
// var path = window.location.pathname;

// // Convert path to class-friendly format
// var pathClass = path
//     // Remove leading slash
//     .replace(/^\//, '')
//     // Replace remaining slashes with hyphens
//     .replace(/\//g, '-')
//     // Replace spaces and special characters with hyphens
//     .replace(/[^a-zA-Z0-9-_]/g, '-')
//     // Remove multiple consecutive hyphens
//     .replace(/-+/g, '-')
//     // Remove leading/trailing hyphens
//     .replace(/^-|-$/g, '')
//     // Convert to lowercase
//     .toLowerCase();

// // Handle empty path (home page)
// if (pathClass === '' || pathClass === '/') {
//     pathClass = 'home';
// }

// // Add prefix to avoid conflicts
// pathClass = 'class-' + pathClass;

// // Add the class to the body
// $('body').addClass(pathClass);
if (window.location.href.indexOf("testing") > -1) {
  jQuery("body").addClass("testing");
} else {
  jQuery("variant-selects").addClass("hidden");
}
function close_popup_scroll_to_registration(){
 $('.lity-close').click();
  setTimeout(function() {
    const $btn = $('.registration_button:visible').first();
    if ($btn.length) {
      $('html, body').animate({
        scrollTop: $btn.offset().top - $(window).height()/2 + $btn.height()/2
      }, 450, () => $btn.addClass('pulse-button'));
    }
  }, 100);
}